import { toObservable } from '@angular/core/rxjs-interop'
import {
  patchState,
  signalStoreFeature,
  withMethods,
  withState,
} from '@ngrx/signals'
import { withEventHandlers } from '@ngrx/signals/events'
import { combineLatest, Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

interface State {
  loading: boolean
  isLoading: boolean
}

export function withLoading<_>(otherStates: Observable<boolean>[] = []) {
  return signalStoreFeature(
    withState({
      loading: false,
      isLoading: false,
    } as State),
    withEventHandlers((store) => ({
      loading$: combineLatest([
        toObservable(store.loading),
        ...otherStates,
      ]).pipe(
        tap((loading) => {
          patchState(store, {
            isLoading: loading.filter((active) => active).length > 0,
          })
        })
      ),
    })),
    withMethods((store) => ({
      setLoading(loading: boolean) {
        patchState(store, { loading })
      },
    }))
  )
}

export function setLoading(loading: boolean): Partial<State> {
  return { loading }
}
